<script>
  import { LAUNCH_EXTERNAL, ZOOM_WARNING_SAFARI } from '../js/l10n/en_US.js';
  import { STREAM_EXTERNAL_SOURCE_TYPE_ZOOM } from '../js/constants.js';
  import Bowser from 'bowser';
  export let url = '',
    sourceType = '';
  let bowser = Bowser.parse(window.navigator.userAgent);
  const showSafariWarning = bowser.browser.name === 'Safari';
</script>

<div class="player-banner">
  {#if sourceType === STREAM_EXTERNAL_SOURCE_TYPE_ZOOM && showSafariWarning}
    <p class="safari-warning-zoom">{ZOOM_WARNING_SAFARI}</p>
  {/if}
  <a href={url} class="btn external-link">{LAUNCH_EXTERNAL}</a>
</div>
